import React from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

import { Answer } from "./Answer"
import { Modal } from "../../../Shared"

export const Question = ({
  answers,
  currentQuestion,
  name,
  nextFunc,
  questionNumber,
  questionValue,
  id,
  tip,
}) => {
  const [desktopGuidance, setDesktopGuidanceVisible] = React.useState("")
  const [
    boilerFlueGuidanceVisisble,
    setBoilerFlueGuidanceVisisble,
  ] = React.useState(false)

  React.useEffect(() => {
    return () => {
      setDesktopGuidanceVisible("")
    }
  }, [])

  return (
    <StaticQuery
      query={graphql`
        query BoilerFlueExamples {
          flueExamples: contentfulAsset(
            contentful_id: { eq: "6jh4gHdjxMBtMhCdWgUQ8l" }
          ) {
            fluid(maxWidth: 2000) {
              ...GatsbyContentfulFluid
            }
          }
        }
      `}
      render={(data) => (
        <div
          className={`boiler-quote-question${
            currentQuestion === questionNumber ? " active" : ""
          }`}
        >
          <h1 className="heading-large">
            <span className="boiler-quote-question-marker"></span>
            {name}
          </h1>
          <p className="boiler-quote-question-tip">
            {tip}{" "}
            {id === "11" ? (
              <button
                className="link-button"
                onClick={() => setBoilerFlueGuidanceVisisble(true)}
              >
                View examples
              </button>
            ) : (
              ""
            )}
          </p>
          <section className="boiler-quote-answers">
            {answers.map((answer) => (
              <Answer
                questionValue={questionValue}
                key={answer.id}
                id={answer.id}
                guidance={answer.guidance}
                illustration={answer.illustration}
                name={answer.name}
                value={answer.value}
                nextFunc={nextFunc}
                setDesktopGuidanceVisible={setDesktopGuidanceVisible}
              />
            ))}
          </section>
          <Modal
            isVisible={boilerFlueGuidanceVisisble}
            heading="Boiler flue examples"
            dismissFunc={() => setBoilerFlueGuidanceVisisble(false)}
          >
            <div className="stat-modal-content">
              <Img fluid={data.flueExamples.fluid} />
            </div>
          </Modal>
          <section className={`boiler-quote-answer-guidance-desktop`}>
            {answers.map((answer) => (
              <p
                key={answer.id}
                className={desktopGuidance === answer.id ? "active" : ""}
              >
                <span className="boiler-quote-answer-guidance-desktop-marker">
                  ?
                </span>
                {answer.guidance}
              </p>
            ))}
          </section>
        </div>
      )}
    />
  )
}

Question.defaultProps = {
  tip: "",
}

Question.propTypes = {
  answers: PropTypes.array.isRequired,
  currentQuestion: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  nextFunc: PropTypes.func.isRequired,
  questionNumber: PropTypes.number.isRequired,
  questionValue: PropTypes.string.isRequired,
  tip: PropTypes.string,
}
